import React, { Fragment } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTh, faBars } from '@fortawesome/free-solid-svg-icons';

//Components
import Item from '../components/Item';
import ListItem from '../components/ListItem';

import Loader from 'react-loader-spinner';
import '../assets/css/SearchContent.scss';

//Redux
import {getParams} from '../store/params/reducer';
import {connect} from 'react-redux';

const SearchContent = ({
  pymes,
  loader,
  total,
  btnLoader,
  displayMoreRcrds,
  search,
  view,
  setView,
  searchTxt,
  searchLocTxt,
  params,
}) => {

  return (
    <Fragment>
      <div className="row padding-results">
        <div className="col-xl-8 results-txt" style={{ paddingTop: '10px' }}>
          <strong>
            {typeof pymes !== 'undefined' ? pymes.length : 0} de {total}
          </strong>{' '}
          Resultados{' '}
          { searchTxt !== ''
            ? 'de '
            : ''}{' '}
          { searchTxt !== ''
            ? <strong> {searchTxt} </strong>
            : ''}{' '}
          { searchLocTxt !== ''
            ? 'de '
            : ''}{' '}
          { searchLocTxt !== ''
            ? <strong> {searchLocTxt} </strong>
            : ''}{' '}
        </div>

        <div
          className="col-xl-4 results-txt btns-grid-list"
          style={{ textAlign: 'right' }}
        >
          <div id="btnContainer">
            <span className="m-r-20" style={{ color: '#929292' }}>
              Visualizar como:
            </span>

            <button
              className={'btn btnG ' + (view === 'grid' ? 'active' : '')}
              onClick={() => setView('grid')}
              style={{ padding: '5px 10px' }}
            >
              <FontAwesomeIcon icon={faTh} className="btn-grid-list" />
            </button>

            <button
              className={'btn btnG ' + (view === 'list' ? 'active' : '')}
              onClick={() => setView('list')}
              style={{ marginLeft: '5px', padding: '5px 10px' }}
            >
              <FontAwesomeIcon icon={faBars} className="btn-grid-list" />
            </button>
          </div>
        </div>
        {loader || typeof pymes === 'undefined' ? (
          <div className="spinner-div-centered">
             <Loader
               type="Oval"
               color="#00BFFF"
               height={50}
               width={50}
               className="spinner-centered"
             />
          </div>
        ) : pymes.length > 0 ? (
          view === 'grid' ? (
            pymes.map((pyme, index) => (
              <Item
                key={index}
                width={'4'}
                image={pyme._source.imagePymeURL}
                title={pyme._source.namePyme}
                specialFactor={pyme._source.specialFactor !== undefined ? pyme._source.specialFactor : ''}
                obj={pyme}
              />
            ))
          ) : (
            pymes.map((pyme, index) => (
              <ListItem
                key={index}
                width={'12'}
                image={pyme._source.imagePymeURL}
                title={pyme._source.namePyme}
                category={pyme._source.categoryArr}
                comune={typeof pyme._source.comune !== 'undefined' ? pyme._source.comune : '' }
                regionName={typeof pyme._source.regionName !== 'undefined' && pyme._source.regionName !== '' ? ', ' + pyme._source.regionName : '' }
                obj={pyme}
              />
            ))
          )
        ) : (
          <div className="col-12">
            <p className="text-center font-weight-bold">
              Sin resultados para la búsqueda realizada
            </p>
          </div>
        )}
      </div>
      {!loader && params.limit < total ? (
        <div className="row align-items-center">
          <div className="col-sm-8 col-md-4" style={{ margin: 'auto' }}>
            <button
              className="btn btn-btn-lg btn-block btn-mas-pymes px-4"
              onClick={() => displayMoreRcrds()}
              disabled={btnLoader}
            >
              Ver más pymes
            </button>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

const mapStateToProps = state => {
  return {
    params: getParams(state)
  };
};

export default connect(mapStateToProps)(SearchContent);
